export { default } from "./Caption";
